module.exports = __webpack_public_path__ + "media/packs/src/webfonts/fa-regular-400-acdccc059cdf7b4063e94a309af2a776.woff";